/** @jsxImportSource @emotion/react */
import React, { useState } from 'react';

import { css } from '@emotion/react';

const AboutUs = (): JSX.Element => {
    const handleScroll = (type: string) => {
        const scroll = document.getElementById('scroll');

        if (scroll) {
            const width = scroll.scrollWidth;
            scroll.scrollLeft += (type === 'left' ? -(width / 8) : (width / 8));
        }
    };

    return (
        <div>

            <div css={styles.section1}>
                {/* <img src='/aboutus_banner.png' alt='banner' css={styles.bannerImage} /> */}
            </div>

            <div css={styles.section2}>
                <h1>Our Story</h1>
                <p>
                    Founded in Johor Bahru in 2003 and rebranded as TIANSI Jewellery in 2010, TIANSI has evolved into a distinguished name in the gold jewellery industry.&nbsp;
                    Renowned for its commitment to quality, innovation and customer satisfaction, TIANSI has expanded its presence with three outlets and on e flagship store.&nbsp;
                    Our journey is marked by a relentless pursuit of excellence and a passion for creating exquisite, customer-focused products and services.
                </p>
                <div css={styles.imgCont2}>
                    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, gap: 20 }}>
                        <div style={{ borderRadius: 12, overflow: 'hidden', width: '100%', height: '100%' }}>
                            <img src='/aboutus2left1.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>

                        <div style={{ borderRadius: 12, overflow: 'hidden', width: '100%', height: '100%' }}>
                            <img src='/aboutus2left.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={{ borderRadius: 12, overflow: 'hidden', width: '100%', height: '100%' }}>
                            <img src='/aboutus2right.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                </div>

                <div css={styles.imgCont3}>
                    <div style={{ display: 'flex', gap: 20 }}>
                        <div style={{ borderRadius: 12, overflow: 'hidden', height: 'auto' }}>
                            <img src='/aboutus2left1.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>

                        <div style={{ borderRadius: 12, overflow: 'hidden', height: 'auto' }}>
                            <img src='/aboutus2left.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>

                        <div style={{ borderRadius: 12, overflow: 'hidden', height: 'auto' }}>
                            <img src='/aboutus2right.png' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        </div>
                    </div>
                </div>
            </div>

            <div css={styles.section3}>
                <div css={styles.section3cont1}>
                    <div>
                        <h1>Our Milestone</h1>
                        <p style={{ fontSize: '1.6rem' }}>
                            Discover the journey behind our brand, where tradition meets innovation, and explore the milestones that have shaped our store&apos;s legacy of passion, dedication, and excellence.
                        </p>
                    </div>
                    <div css={styles.arrowIcon}>
                        <div
                            role='button'
                            tabIndex={0}
                            onClick={() => handleScroll('left')}
                            onKeyPress={() => handleScroll('left')}
                        >
                            <img src='/assets/icons/ArrowLeftCircle.svg' alt='' />
                        </div>
                        <div
                            role='button'
                            tabIndex={0}
                            onClick={() => handleScroll('right')}
                            onKeyPress={() => handleScroll('right')}
                        >
                            <img src='/assets/icons/ArrowLeftCircle.svg' alt='' style={{ transform: 'rotate(180deg)' }} />
                        </div>
                    </div>
                </div>

                <div id='scroll' style={{ overflow: 'auto', scrollBehavior: 'smooth', scrollbarColor: '#064E72 #064E72' }}>
                    <div css={styles.section3ImageContainer}>
                        {/* <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 50 }}>
                            <div style={{ width: '100%' }}>
                                <div css={styles.section3Bartext}>
                                    <p id='03'>2003</p>
                                    <p id='08' style={{ paddingLeft: 70 }}>2008</p>
                                    <p id='16'>2016</p>
                                </div>
                                <img src='/aboutUsBar.svg' alt='white bar' style={{ width: '100%', height: 'auto' }} />
                            </div>
                            <div style={{ width: '100%' }}>
                                <div css={styles.section3Bartext}>
                                    <p id='03'>2003</p>
                                    <p id='08' style={{ paddingLeft: 70 }}>2008</p>
                                    <p id='16'>2016</p>
                                </div>
                                <img src='/aboutUsBar.svg' alt='white bar' style={{ width: '100%', height: 'auto' }} />
                            </div>
                            <div style={{ width: '100%' }}>
                                <div css={styles.section3Bartext}>
                                    <p id='03'>2003</p>
                                    <p id='08' style={{ paddingLeft: 70 }}>2008</p>
                                    <p id='16'>2016</p>
                                </div>
                                <img src='/aboutUsBar.svg' alt='white bar' style={{ width: '100%', height: 'auto' }} />
                            </div>
                        </div> */}

                        <div css={styles.section3cont2}>
                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2003</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img1.png' alt='' />
                                </div>
                                <p>
                                    Started as a humble wholesale business, marking the beginning of our commitment to delivering exquisite gold.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2008</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img2.png' alt='' />
                                </div>
                                <p>
                                    Opened the first store which set the foundation for our future growth and expansion.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2010</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img3.webp' alt='' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                </div>
                                <p>
                                    Rebranded ourselves as TIANSI Jewellery, a name that reflects our dedication to excellence and innovation.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2016</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img4.png' alt='' />
                                </div>
                                <p>
                                    Opened our first branch at Mydin Taman Rinting, marking the beginning of our expansion journey.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2018</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img5.webp' alt='' />
                                </div>
                                <p>
                                    Expanded further with the launch of new outlets in Mount Austin, which also became our headquarters and office.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2019</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img6.webp' alt='' />
                                </div>
                                <p>
                                    Despite the challenges posed by the COVID-19 pandemic, our e-commerce platform thrived, achieving significant monthly sales. This success underscored our ability to adapt and innovate in a rapidly changing market.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2020</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img7.webp' alt='' />
                                </div>
                                <p>
                                    Opened a new outlet in MidValley Southkey, one of the largest malls in the southern part of West Malaysia, enhancing our visibility and accessibility.
                                </p>
                            </div>

                            <div>
                                <h1 style={{ textAlign: 'center', marginBottom: 20 }}>2023</h1>
                                <div style={{ width: '500px', height: '330px', overflow: 'hidden', borderRadius: 12 }}>
                                    <img src='/aboutus3img8.webp' alt='' />
                                </div>
                                <p>
                                    Continued our expansion with a new branch in Seri Alam, further solidifying our market presence and commitment to growth.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>

                <div css={styles.arrowIconMobile}>
                    <div
                        aria-label='chevron left'
                        role='button'
                        tabIndex={0}
                        onClick={() => handleScroll('left')}
                        onKeyPress={() => handleScroll('left')}
                    >
                        <img src='/assets/icons/ArrowLeftCircle.svg' alt='' />
                    </div>
                    <div
                        aria-label='chevron right'
                        role='button'
                        tabIndex={0}
                        onClick={() => handleScroll('right')}
                        onKeyPress={() => handleScroll('right')}
                    >
                        <img src='/assets/icons/ArrowLeftCircle.svg' alt='' style={{ transform: 'rotate(180deg)' }} />
                    </div>
                </div>
            </div>

            <div css={styles.section4}>
                <div css={styles.section4left}>
                    <div>
                        <h1>Our Mission</h1>
                        <p>
                            At TIANSI, our mission is to enrich lives with exceptional quality of gold and jewelry, integrating creativity with dedication. We empower clients, suppliers and employees to elevate their lifestyles and knowledge through the gold and jewelry industry, fostering insightful conversations and enhancing the community.
                        </p>
                    </div>

                    <div>
                        <h1>Our Vision</h1>
                        <p>
                            TIANSI aims to be Malaysia&apos;s most preferred gold and jewellery retailer, leading in fashion and style trends. We are committed to expanding our presence, with a focus on strengthening operations in Johor and extending to new markets across Malaysia.
                        </p>
                    </div>
                </div>
                <div>
                    <img src='/aboutus4.png' alt='' style={{ width: '100%', height: 'auto', borderRadius: 12 }} />
                </div>
                <div css={styles.section4right}>
                    <div>
                        <h1>Our Mission</h1>
                        <p>
                            At TIANSI, our mission is to enrich lives with exceptional quality of gold and jewelry, integrating creativity with dedication. We empower clients, suppliers and employees to elevate their lifestyles and knowledge through the gold and jewelry industry, fostering insightful conversations and enhancing the community.
                        </p>
                    </div>

                    <div>
                        <h1>Our Vision</h1>
                        <p>
                            TIANSI aims to be Malaysia&apos;s most preferred gold and jewellery retailer, leading in fashion and style trends. We are committed to expanding our presence, with a focus on strengthening operations in Johor and extending to new markets across Malaysia.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    title: css({
        fontSize: '3rem',
        fontWeight: 700,
        letterSpacing: 1,
    }),
    text: css({
        marginTop: 25,
        fontFamily: 'AcuminRPro',
        fontSize: '1.2rem',
        maxWidth: 780,
        textAlign: 'center',
    }),

    section1: css({
        backgroundImage: 'url(/aboutus_banner.png)',
        backgroundPosition: 'bottom',
        backgroundSize: 'cover',
        overflow: 'hidden',
        '@media(min-width:300px)': {
            height: '30vh',
        },
        '@media(min-width:768px)': {
            height: '40vh',
        },
        '@media(min-width:1024px)': {
            height: '70vh',
        },
        '@media(min-width:1200px)': {
            height: '80vh',
        },
    }),

    bannerImage: css({
        '@media(min-width:300px)': {
            width: '100%',
            height: 280,
            objectFit: 'cover',
        },
        '@media(min-width:768px)': {
            width: '100%',
            height: 420,
            objectFit: 'cover',
        },
        '@media(min-width:1200px)': {
            width: '100%',
            height: 'auto',
            backgroundPosition: 'center',
        },

    }),

    section2: css({
        '@media(min-width:300px)': {
            display: 'flex',
            flexDirection: 'column',
            padding: 20,
            paddingTop: 60,
            paddingBottom: 60,

            '& h1': {
                fontSize: '3rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 5,
                fontFamily: 'AcuminRPro',
                fontSize: '1.72rem',
                color: '#616161',
            },
            '#scrollable': {
                overflow: 'auto',
                scrollBehavior: 'smooth',
            },
        },
        '@media(min-width:1200px)': {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            paddingTop: 0,
            paddingBottom: 0,
            marginTop: 50,
            marginBottom: 50,
            height: '90vh',
            '& h1': {
                fontSize: '4rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 25,
                fontFamily: 'AcuminRPro',
                fontSize: '1.85 rem',
                maxWidth: 1200,
                textAlign: 'center',
                color: '#616161',
            },
            // '& div': {
            //     flex: 1,
            //     gap: 20,
            //     borderRadius: 12,
            // overflow: 'hidden',
            // },
        },
    }),
    imgCont2: css({
        gap: 20,
        '@media(min-width:300px)': {
            display: 'none',
        },

        '@media(min-width:1200px)': {
            overflow: 'clip',
            display: 'flex',
            width: '55%',
            paddingTop: 20,
        },
    }),
    imgCont3: css({

        '@media(min-width:300px)': {
            display: 'flex',
            overflow: 'auto',
            scrollBehavior: 'smooth',
            maxWidth: '100%',
            maxHeight: '200px',
            '>div': {
                '>div': {
                    width: '200px',
                },
            },
        },

        '@media(min-width:768px)': {
            maxHeight: '300px',
            '>div': {
                '>div': {
                    width: '400px',
                },
            },
        },

        '@media(min-width:1200px)': {
            display: 'none',
        },
    }),
    section3: css({
        '@media(min-width:300px)': {
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: '#064E72',
            color: 'white',
            padding: 20,
            paddingTop: 60,
            paddingBottom: 60,
            '& h1': {
                fontSize: '3rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 5,
                fontFamily: 'AcuminRPro',
                fontSize: '1.75rem',
            },
        },
        '@media(min-width:1200px)': {
            display: 'flex',
            flexDirection: 'column',
            padding: 100,
            backgroundColor: '#064E72',
            color: 'white',
            '& h1': {
                fontSize: '3rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 25,
                fontFamily: 'AcuminRPro',
                fontSize: '1.2rem',
                maxWidth: 780,
            },
        },
    }),
    section3cont1: css({
        display: 'flex',
        '>div': {
            flex: 1,
        },
    }),
    arrowIcon: css({
        '@media(min-width:300px)': {
            display: 'none',
        },
        '@media(min-width:1200px)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: 30,
            '>div': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end',
            },
            '& img': {
                width: 70,
                height: 70,
            },
        },

    }),
    arrowIconMobile: css({
        '@media(min-width:300px)': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingTop: 30,
            gap: 10,
            '& img': {
                width: 40,
                height: 40,
            },
        },
        '@media(min-width:1200px)': {
            display: 'none',
        },

    }),
    section3Bartext: css({
        display: 'flex',
        justifyContent: 'space-between',
        width: '81%',
        '& p': {
            fontFamily: 'Playfair',
            fontSize: '2rem',
            fontWeight: 700,
        },
    }),
    section3ImageContainer: css({

        '@media(min-width:300px)': {
            width: '800%',
        },
        '@media(min-width:768px)': {
            width: '500%',
        },
        '@media(min-width:1200px)': {
            width: '265%',

        },
    }),
    section3cont2: css({
        display: 'flex',
        gap: 20,
        paddingTop: 40,

        '>div': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            '>div': {
                '>img': {
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    borderRadius: 12,
                },
            },

            '>p': {
                fontSize: '1.6rem',
            },
        },
    }),
    section4: css({
        '@media(min-width:300px)': {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            padding: 20,
            paddingTop: 80,
            paddingBottom: 80,
            '& div': {
                width: '100%',
            },
        },
        '@media(min-width:1200px)': {
            display: 'flex',
            flexDirection: 'row',
            gap: 60,
            padding: 100,
            paddingTop: 150,
            paddingBottom: 150,
            '& div': {
                width: '100%',
            },
        },
    }),
    section4left: css({
        '@media(min-width:300px)': {
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            '& h1': {
                fontSize: '3.4rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 15,
                fontFamily: 'AcuminRPro',
                fontSize: '1.72rem',
                maxWidth: 780,
                textAlign: 'left',
                color: '#616161',
            },
        },
        '@media(min-width:1200px)': {
            display: 'none',
        },
    }),
    section4right: css({
        '@media(min-width:300px)': {
            display: 'none',
        },
        '@media(min-width:1200px)': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 50,

            '& h1': {
                fontSize: '3.8rem',
                fontWeight: 700,
                letterSpacing: 1,
            },
            '& p': {
                marginTop: 25,
                fontFamily: 'AcuminRPro',
                fontSize: '1.75rem',
                maxWidth: 780,
                textAlign: 'left',
                color: '#616161',
            },
        },
    }),
};

export default AboutUs;
